import styled from 'styled-components';
import { Button } from '../../utils/Button/Button';
import { Text14Regular, Text16Bold, Text18Bold } from '../../utils/Text/Text.styles';

export const Form = styled.form`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const StyledButton = styled(Button)`
  width: 35rem;
  margin-top: auto;
  margin-inline: auto;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }
`;

export const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }
`;

export const Label = styled(Text16Bold)`
  letter-spacing: -0.42px;
  margin-bottom: 0.4rem;
  margin-top: ${({ $marginTop }) => ($marginTop ? `${$marginTop / 10}rem` : '0.3rem')};
`;

export const Text = styled(Text14Regular)`
  line-height: 18px;
  opacity: 0.56;
  margin-bottom: 1.2rem;
`;

export const SelectedMediaContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 0.2rem;
  padding: 1rem 0;
`;

export const AddMediaButton = styled.button`
  height: 15rem;
  min-width: 15rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.2rem;
  border-radius: 4.933px;
  border: 1.233px dashed #97c9f1;
  background: #fff;
`;

export const AddMediaText = styled(Text18Bold)`
  color: #1672ba;
  letter-spacing: -0.408px;
`;
